"use client";

import React, { useState } from "react";
import { Segment } from "../../_shims/semantic-ui-react";
import { ButtonItem } from "../../../components";
import AgentContact from "../../../components/AgentContact";

export default function ExpertContactSection({ neighborhoodname }) {
  const [showAgentPopup, setShowAgentPopup] = useState(false);

  const openAgentPopup = () => {
    setShowAgentPopup(true);
  };

  const closeAgentPopup = () => {
    setShowAgentPopup(false);
  };

  return (
    <Segment
      basic
      className="expert_segment"
      style={{ paddingBottom: "0px", marginBottom: "0px" }}
    >
      <div className="expert_contact_section">
        <p>Looking to Buy or Sell?</p>
        <ButtonItem primary fluid onClick={openAgentPopup}>
          Contact a Neighborhood Expert
        </ButtonItem>
        <AgentContact
          open={showAgentPopup}
          onClose={closeAgentPopup}
          neighborhoodname={neighborhoodname}
        />
      </div>
    </Segment>
  );
}
